import { Theme } from '@desygner/ui-common-components';

export const {
  X3Small,
  X2Small,
  XSmall,
  Small,
  Medium,
  Large,
  XLarge,
  X2Large,
  X3Large,
  X4Large,
  X5Large,
  X6Large,
  X7Large,
  X8Large,
} = Theme.Sizes;
